import { render } from "./About.vue?vue&type=template&id=3a643ae1"
const script = {}
script.render = render

export default script